// because of Vite 8 uses rollup bundling, we need to import Prism before and set it globally
import Prism from "prismjs"
;(globalThis as unknown as { Prism?: unknown }).Prism = Prism

import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import * as Sentry from "@sentry/react"

import { StorageKeys } from "types/enums/StorageKeys"

import { setViewportHeight } from "utils/deviceDetection"
import { getStorageItem } from "utils/localStorage"
import { setSentryUserContext } from "utils/sentryUserContext"

import { App } from "./App"
import config from "./config"
import { store } from "./store/index"

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", config.BASE_URL_API || ""],
    environment: config.STAGE || "qa",
  })

  const userProfile = getStorageItem(StorageKeys.UserProfile)
  if (userProfile && typeof userProfile === "object") {
    setSentryUserContext(userProfile)
  }
}

setViewportHeight()

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    <ToastContainer />
  </Provider>,
)
